/** Coerce a @solidjs/router search-param value (string | string[]) to one string. */
export function singleParam(
  value: string | string[] | undefined,
): string | null {
  if (Array.isArray(value)) {
    return value[0] ?? null;
  }
  return value ?? null;
}
